import axios, { AxiosInstance } from "axios";

import { AGMS_BASE_URL, AGMS_SERVER, REQUST_TIMEOUT } from "../util/environment";

let axiosInstanceAGMS: AxiosInstance | undefined;

let accessTokenAGMS = "";

export const getAxiosInstanceAGMS = (): AxiosInstance => axiosInstanceAGMS!;

const setAccessTokenAGMS = (newAccessTokenAGMS: string): void => {
  accessTokenAGMS = newAccessTokenAGMS;
};

export const initInterceptors = (): void => {
  getAxiosInstanceAGMS().interceptors.request.use(
    async (config) => {
      if (config && config.headers) {
        config.headers.Authorization = `Bearer ${accessTokenAGMS}`;
      }

      return config;
    },
    (error) => {
      console.log(`Problem ${error}`);

      return Promise.reject(error);
    }
  );
};

export const initAxiosAGMS = (initialAccessTokenAGMS: string): void => {
  setAccessTokenAGMS(initialAccessTokenAGMS);

  axiosInstanceAGMS = axios.create({
    baseURL: `${AGMS_BASE_URL}/${AGMS_SERVER}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    timeout: REQUST_TIMEOUT,
  });

  initInterceptors();
};

export default axiosInstanceAGMS;
